/** Shared by the two box lists: a tenant's own boxes and the box templates. */

/** Longest slug the box create forms fill in from the name. */
export const MAX_BOX_SLUG_LENGTH = 80;

/**
 * Mirrors `boxes.list`'s server-side search so one input can filter a list held
 * in memory: substring on name or slug, whole-string on the id (ULIDs all share
 * a prefix, so substring-matching them would make short terms hit every row).
 */
export function matchesSearch(
  box: { name: string; slug: string; id: string },
  term: string,
): boolean {
  if (!term) return true;
  const t = term.toLowerCase();
  return (
    box.name.toLowerCase().includes(t) ||
    box.slug.toLowerCase().includes(t) ||
    box.id.toLowerCase() === t
  );
}
